<template>
	<div class="page-main">
		<div class="camp_detail_container" v-if="detailData">

			<!-- 手机端扫码访问 -->
			<div style="width: 150px; height: 40px; position: fixed; bottom: 40px; right: 20px; z-index: 999;">
				<el-popover placement="bottom" width="200" trigger="click">

					<div
						style="display: flex;  flex-direction: column;justify-content: center; align-items: center;width: 100%; height: 200px;">
						<div ref="qrcode" style="width: 120px; height: 120px;"></div>
						<div
							style="font-size: 13px; width: 200; margin-top: 15px;display: flex;flex-direction: column; align-items: center;">
							扫码访问手机版详情页
						</div>
					</div>

					<el-button slot="reference">手机版二维码</el-button>
				</el-popover>
			</div>

			<!-- 会议周期 -->
			<div class="class_product_box" v-if="detailData.class_product_list && detailData.class_product_list.length>0">
				
				<!-- 手风琴效果 -->
				<!-- 
				<el-collapse value="1" accordion>
					<el-collapse-item name="1">
						<template slot="title">
							<div class="class_product_box_title">
								查看往届会议
							</div>
						</template>
						<div class="class_product_items">
							<div class="class_product_item" :class="{'active':item.is_current == 1}"
								@click="GoToDetail(item.product_type, item.product_id)"
								v-for="(item,index) in detailData.class_product_list">
								<div class="current" v-if="item.is_current == 1">
									<i class="el-icon-check icon"></i>
								</div>
								<div class="time">{{item.time}}</div>
								<div class="title">
									<div class="class_order_title">{{item.class_order_title}}</div>
									<div>
										<div v-if="item.is_stop == 1">已结束</div>
										<div v-if="item.is_stop == 0">
											<span v-if="item.ts_start_at!=0">报名中</span>
											<span v-if="item.ts_start_at==0">进行中</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse> 
				-->
				
				
				<div class="class_product_box_title" v-if="!show" @click="show=true">
					<span v-if="detailData.class_product_list[0].class_type == 1">查看往届会议</span><span v-if="detailData.class_product_list[0].class_type == 2">查看往期培训</span> <i class="el-icon-more icon"></i>
				</div>
				<div class="class_product_items" v-if="show">
					<div class="class_product_item" :class="{'active':item.is_current == 1}"
						@click="GoToDetail(item.product_type, item.product_id)"
						v-for="(item,index) in detailData.class_product_list">
						<div class="current" v-if="item.is_current == 1">
							<i class="el-icon-check icon"></i>
						</div>
						<div class="time">{{item.time}}</div>
						<div class="title">
							<div class="class_order_title">{{item.class_order_title}}</div>
							<div>
								<div v-if="item.is_stop == 1">已结束</div>
								<div v-if="item.is_stop == 0">
									<span v-if="item.ts_start_at!=0">报名中</span>
									<span v-if="item.ts_start_at==0">进行中</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="close_box" v-if="show">
					<div class="line"></div>
					<div class="close" @click="show=false">
						<i class="el-icon-close icon"></i>
					</div>
				</div>

			</div>



			<div
				style=" position: sticky; left: 0; top: 0; width:100%;height: 70px;background:linear-gradient(to right,#F1F9FB,#F6FAFD); display: flex; justify-content: center;border-bottom: 1px solid #eaeaea;">

				<!-- 论文点评活动提示 -->
				<!-- <div @click="noteClick" v-if="id=='t_65e37a63f97346e7be8f42f38431c926'" style="position: absolute;left: 0; bottom: -32px; z-index: 999; background-color: #fdf6ec; display: flex; justify-content: center; width: 100%; height: 36px; color:#f90; font-size: 15px;  padding: 0 15px; box-sizing: border-box;cursor: pointer;">
					<div style=" width: 1200px; display: flex; justify-content: space-between;">
						<span style="display: flex; align-items: center;"><i class="el-icon-message-solid"></i>论文点评与推荐活动</span>
						<span style="display: flex;  align-items: center;">详情 <i class="el-icon-d-arrow-right"></i></span>
					</div>
				</div> -->
				
				<!-- 核刊特约投稿活动提示 -->
				<div @click="noteClick" v-if="id=='t_eeb95d53e54b4deaa160ce6fb04e09b3'" style="position: absolute;left: 0; bottom: -32px; z-index: 999; background-color: #fdf6ec; display: flex; justify-content: center; width: 100%; height: 36px; color:#f90; font-size: 15px;  padding: 0 15px; box-sizing: border-box;cursor: pointer;">
					<div style=" width: 1200px; display: flex; justify-content: space-between;">
						<span style="display: flex; align-items: center;"><i class="el-icon-message-solid"></i>核刊特约投稿活动进行中...</span>
						<span style="display: flex;  align-items: center;">详情 <i class="el-icon-d-arrow-right"></i></span>
					</div>
				</div>

				<!-- 团购提示 -->
				<div v-if="detailData.is_show_joiner == 1"
					style="position: absolute;left: 0; bottom: -32px; z-index: 999; background-color: #fdf6ec; display: flex; justify-content: center; width: 100%; height: 36px; color:#f90; font-size: 15px;  padding: 0 15px; box-sizing: border-box;cursor: pointer;">
					<div style=" width: 1200px;">
						专属团购入口，报名满<span style="font-weight: 600; padding: 0 5px;"> 50 </span>人，系统自动改价，当前已报名 <span
							style="font-weight: 600; padding: 0 5px;"> {{detailData.joiner_count}} </span>人
					</div>
				</div>

				<div style="width: 1200px;display: flex; justify-content: space-between; position: relative;">

					<div style="display: inline-flex;font-size: 20px;align-items: center; ">
						<div style="color: #c93a2e; font-weight: 600;">CMPTT</div>
						<div style="color: #999;margin: 0 10px;">|</div>
						<div style="color: #999;">{{detailData.title}}</div>
					</div>

					<div style="display: inline-flex;align-items: center;">

						<div style="color: #333; margin-right: 15px; display: flex; "
							v-if="detailData.is_display_price == 1 && detailData.state != 2 && (!detailData.status || (detailData.status && detailData.status.status_code == 2))">
							<div style="display: inline-flex; align-items: center;font-weight: 400;"
								v-if="detailData.is_early_bird==1">
								<div style="color: #c93a2e; font-size: 16px; width: 16px; line-height: 1.1;  ">早鸟价</div>
								<div
									style="display: flex;flex-direction: column; align-items: center; margin-left: 10px; line-height: 1;">
									<div style="color: #c93a2e; font-size: 30px;"
										v-if="detailData.price.indexOf('~') ==-1">¥{{detailData.price}}</div>
									<div style="color: #c93a2e; font-size: 26px;"
										v-if="detailData.price.indexOf('~') !=-1">¥{{detailData.price}}</div>
									<div
										style="color: #999; font-size: 17px; text-decoration: line-through; margin-top: 2px;">
										原价：¥{{detailData.line_price}}</div>
								</div>
							</div>
							<div v-if="detailData.is_early_bird==0">
								<div v-if="!detailData.student_price && detailData.price!=0"
									style="color: #c93a2e; font-size: 30px;">¥{{detailData.price}}</div>
								<div v-if="detailData.student_price"
									style="display: flex;flex-direction: column; align-items: center; margin-left: 10px; line-height: 1;">
									<div style="color: #c93a2e; font-size: 30px;">¥{{detailData.price}}</div>
									<div style="color: #999; font-size: 17px; margin-top: 2px;">
										学生价：¥{{detailData.student_price}}</div>
								</div>
							</div>
						</div>

						<div
							style="border: 1px solid #c93a2e;color: #c93a2e; border-radius: 30px; width: 130px; height: 30px; display: flex;justify-content: center; align-items: center; cursor: pointer;margin-right:30px; ">
							<el-popover placement="bottom" width="240" trigger="click">
								<div
									style="z-index: 999; display: flex; flex-direction: column;justify-content: center; align-items: center;">
									<div
										style="display: flex;  flex-direction: column;justify-content: center; align-items: center;width: 180px;">
										<img :src="detailData.kf_qrcode_img_url" style="width: 180px; height: auto; " />
										<div
											style="font-size: 13px; width: 180px; margin-top: 5px;display: flex;flex-direction: column; align-items: center;">
											<div>扫描上方二维码添加客服微信号</div>
											<div>加好友时请备注：会议名称+姓名+学校</div>
										</div>
									</div>
									<div
										style=" width: 180px; display: flex;  flex-direction: column;justify-content:  flex-start; margin-top: 8px; line-height: 1.75;  font-size: 13px;">
										<div style="display: flex;">
											<div>电话咨询：</div>
											<div style="display: flex;flex-direction: column;">
												<div>010-88373033</div>
												<div>010-88378723</div>
											</div>
										</div>
										<div style="margin-top: 5px;">
											邮件咨询：service@cmptt.com
										</div>
										<div style="margin-top: 5px;">人工在线时间：</div>
										<div>工作日，9:00~17:30</div>
									</div>
								</div>
								<div style=" display: flex; justify-content: center; align-items: center;"
									slot="reference">
									立即咨询
								</div>
							</el-popover>
						</div>




						<div v-if="id!='t_27423f35fe694b83a9457f5f173e15a0' && detailData.res && detailData.state != 2"
							@click="downloadClick(detailData.res)"
							style="border: 1px solid #c93a2e;color: #c93a2e; border-radius: 30px; width: 130px; height: 30px; display: flex;justify-content: center; align-items: center;cursor: pointer;margin-right:30px;">
							下载会议通知</div>

						<div v-if="id=='t_27423f35fe694b83a9457f5f173e15a0'"
							style="border: 1px solid #c93a2e;color: #c93a2e; border-radius: 30px; width: 130px; height: 30px; display: flex;justify-content: center; align-items: center; cursor: pointer;margin-right:30px; ">
							<el-popover placement="bottom" width="200" trigger="hover">
								<div style="font-size: 15px;">
									<div @click="downloadClick(detailData.res)"
										style="padding:10px 15px; border: 1px solid #eee; margin-bottom: 10px; box-sizing: border-box;cursor: pointer;">
										<i class="el-icon-download" style="margin-right: 5px;"></i>会议通知一
									</div>
									<div @click="downloadClick2()"
										style="padding:10px 15px; border: 1px solid #eee; box-sizing: border-box;cursor: pointer;">
										<i class="el-icon-download" style="margin-right: 5px;"></i>会议通知二
									</div>
								</div>
								<div style=" display: flex; justify-content: center; align-items: center;"
									slot="reference">
									下载会议通知
								</div>
							</el-popover>
						</div>


						<!-- 工业互联网 -->
						<div v-if="id == 't_8n29da89c6205b478d9987f083f5594f' || id == 't_8i4d1cf92190324a0a9ab655ced72f9f' || id == 't_8lfcccee3702384f5f9a7336bcf87281'"
							style="background: #ccc; color: #fff; border-radius: 30px;width: 130px; height: 30px; display: flex;justify-content: center; align-items: center;">
							暂停报名</div>

						<div v-if="id == 't_8531640d53044cd1826970d2506a3933' || id == 't_439a8fabcb614ff29eaa4c2d465004ba'" @click="signUpClick"
							style="background: #ccc; color: #fff; border-radius: 30px;width: 130px; height: 30px; display: flex;justify-content: center; align-items: center; cursor: pointer;">
							会议延期
						</div>

						<div
							v-if="id != 't_439a8fabcb614ff29eaa4c2d465004ba' &&  id != 't_8n29da89c6205b478d9987f083f5594f' && id != 't_8i4d1cf92190324a0a9ab655ced72f9f' && id != 't_8lfcccee3702384f5f9a7336bcf87281' && id!='t_8531640d53044cd1826970d2506a3933'">

							<!-- <div> -->
							<div
								v-if="(!detailData.status || (detailData.status && detailData.status.status_code == 2)) && detailData.state!=2">

								<div v-if="detailData.is_reg == 0">
									<div @click="signUpClick" v-if="detailData.is_close == 0"
										style="background: linear-gradient(to right,#c93a2e,#ff9000); color: #fff; border-radius: 30px;width: 130px; height: 30px; display: flex;justify-content: center; align-items: center;cursor: pointer; position: relative;">
										<span v-if="detailData.is_open_pay == 0">预报名</span>
										<div v-if="detailData.is_open_pay == 0 && detailData.is_open_pay_message"
											style="  width: 200px;position: absolute; bottom: -20px; font-size: 12px; color: #666; display: flex; justify-content: center;">
											{{detailData.is_open_pay_message}}
										</div>
										<span v-if="detailData.is_open_pay == 1">立即报名</span>
									</div>
									<div v-if="detailData.is_close == 1"
										style="background: #ccc; color: #fff; border-radius: 30px;width: 130px; height: 30px; display: flex;justify-content: center; align-items: center;cursor: pointer; position: relative;">
										报名截止
									</div>
								</div>
								<div @click="signUpClick" v-if="detailData.is_reg == 1"
									style="background: linear-gradient(to right,#c93a2e,#ff9000); color: #fff; border-radius: 30px;width: 130px; height: 30px; display: flex;justify-content: center; align-items: center;cursor: pointer;">
									<span v-if="detailData.is_open_pay == 0">预报名成功</span>
									<span v-if="detailData.is_open_pay == 1">报名成功</span>
								</div>
							</div>
							<div v-if="detailData.status && detailData.status.status_code == 1" @click="studyClick"
								style="background: linear-gradient(to right,#c93a2e,#ff9000); color: #fff; border-radius: 30px;width: 130px; height: 30px; display: flex;justify-content: center; align-items: center;cursor: pointer;">
								<span v-if="detailData.is_open_study == 1">立即学习</span>
								<span v-if="detailData.is_open_study != 1">报名成功</span>
							</div>
							<div v-if="detailData.state == 2 && ((detailData.status && detailData.status.status_code != 1) ||  !detailData.status || out_trade_no)"
								style="background: #ccc; color: #fff; border-radius: 30px;width: 130px; height: 30px; display: flex;justify-content: center; align-items: center;position: relative;">
								<span>已经结束</span>
								<!-- <span v-if="id=='t_8jaa9f66f964fe41b69886ef9cebbf3f'" style="width: 200px;position: absolute; bottom: -20px; font-size: 12px; color: #666; display: flex; justify-content: center;">第1期报名已结束，第2期请期待</span> -->
							</div>
						</div>

					</div>

				</div>

			</div>

			<!-- 手机端扫码访问 -->
			<!-- <div  style="width: 120px; height: 40px; position: fixed; bottom: 20px; right: 20px;">
				<el-popover
				  placement="left"
				  width="240"
				  trigger="click"
				>
				 <div style="z-index: 999; display: flex; flex-direction: column;justify-content: center; align-items: center;">
					<div style="display: flex;  flex-direction: column;justify-content: center; align-items: center;width: 180px;">
						<div ref="qrcode" style="width: 230px; height: 230px;"></div>
						<div style="font-size: 13px; width: 180px; margin-top: 5px;display: flex;flex-direction: column; align-items: center;">
							扫码访问手机版详情页
						</div>
					</div>
				 </div>
				 <div style=" display: flex; justify-content: center; align-items: center;" slot="reference">
					访问手机版详情
				 </div>
				</el-popover>
			</div> -->

			<div style="display: flex;flex-direction: column; width: 100%;" v-html="detailData.description"></div>


		</div>
	</div>
</template>

<script>
	import apiUrl from "../../js/apiUrl.js";
	import comm from "../../js/comm.js";
	import download from 'downloadjs';
	import QRCode from "qrcodejs2";


	export default {
		data() {
			return {
				id: null,
				path: null,
				coupon_code: null,
				detailData: null,
				isLogin: false,
				show : true,
			};
		},
		created() {
			document.title = "教师特训营 - 机工教师特训营";
			this.isLogin = localStorage.getItem("userLogInInfo") ? true : false;
			console.log(this.isLogin);

			var option = {
				id: this.$route.query.id || "",
				path: this.$route.query.path || "",
				coupon_code: this.$route.query.coupon_code || "",
			};
			if (option.id) {
				this.id = option.id;
				if (option.path) {
					this.path = option.path;
				}
				if (option.coupon_code) {
					this.coupon_code = option.coupon_code;
				}
				this.getDetail();
			}
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				if (vm.isMobilePhone()) {
					var url = 'https://m.cmptt.com/pages/camp/campDetails?id=' + vm.$route.query.id;
					if (vm.$route.query.path) {
						url += '&path=' + vm.$route.query.path;
					}
					if (vm.$route.query.coupon_code) {
						url += '&coupon_code=' + vm.$route.query.coupon_code;
					}
					if (url) {
						window.location.href = url;
					}
				}
			});
		},
		components: {
			qrcode: QRCode,
		},
		methods: {
			closeClick(){
				this.show = false;
			},
			noteClick() {
				if(this.id == 't_eeb95d53e54b4deaa160ce6fb04e09b3'){
					this.$alert('<img src="https://images.cmptt.com/h5/cmptt/detail/pc_20260507172399.jpg" style="width:100%"/>','提示', {
						customClass: 'notebox',
						dangerouslyUseHTMLString: true
					}); 
				}else if(this.id == 't_65e37a63f97346e7be8f42f38431c926'){
					this.$alert('<img src="https://images.cmptt.com/h5/cmptt/detail/pc_20250813184010.jpg" style="width:100%"/>','提示', {
						customClass: 'notebox',
						dangerouslyUseHTMLString: true
					}); 
				}
			},
			isMobilePhone() {
				const ua = navigator.userAgent.toLowerCase();
				const t1 =
					/android|webos|iphone|ipod|blackberry|iemobile|opera mini|opera mobile|applewebkit.*mobile|mobile/i
					.test(ua);
				return t1;
			},
			downloadClick(item) {
				download(item.file_path, item.file_name);
			},
			downloadClick2() {
				var file_path = 'https://images.cmptt.com/h5/cmptt/conference/file/pdf/1743065782/202503311608000.pdf';
				var file_name = '机械制图课程教学改革讨会暨教师能力提升特训营通知(3.27).pdf';
				download(file_path, file_name);
			},
			getDetail() {
				var that = this;
				var url = apiUrl.tt_camp_detail_get;
				var parms = {
					id: this.id
				};
				if (this.path) {
					parms = {
						id: this.id,
						path: this.path
					};
				}
				this.Ajax(url, parms, (data) => {
					that.detailData = data;
					document.title = data.title + " - 教师特训营 - 机工教师特训营";

					var mobile_qrcode_url = 'https://m.cmptt.com/pages/camp/campDetails?id=' + that.id;
					if (that.path) {
						mobile_qrcode_url += '&path=' + that.path;
					}
					if (that.coupon_code) {
						mobile_qrcode_url += '&coupon_code=' + that.coupon_code;
					}

					that.$nextTick(() => {
						that.setupQrCode(that.$refs.qrcode, mobile_qrcode_url, 120, (
							code_img) => {
							that.qrcode = code_img;
						});
					});
				});
			},
			signUpClick() {
				if (this.id == 't_8qa585b25d743d4df3add040fc39317f') {

					window.open('https://meeting.cmes.org/?sid=1185&mid=296&v=100', "_blank");

				} else if (this.id == 't_b086fd30d0814e18bd18736bc14c6cd5') {

					window.open('https://docs.qq.com/form/page/DWFRZRFd1cWtCbFVX', "_blank");


				} else if (this.id == 't_8u23b69ca04989462a942cac80ffbfef') {

					this.$alert('会议正在进行中，线上内容暂未开放，敬请期待······', '温馨提示', {
						confirmButtonText: '确定'
					});

				} else if (this.id == 't_c2891c7e62e64008bb27d5ce37e4a9ca') {

					this.$alert('本课程暂不开放报名，作者老师请联系编辑获取激活码，领取课程权限', '温馨提示', {
						confirmButtonText: '确定',
					});

				} else if (this.id == 't_8531640d53044cd1826970d2506a3933') {
					this.$alert(
						'原定于7月16日-18日于连云港召开的中国机械工业教育协会应用型本科机械工程专业委员会年会，因相关规定要求及时间冲突等原因决定改期，具体日期另行通知，请各位委员妥善更改行程，对造成的不便非常抱歉。会议组委会2025年7月1日',
						'温馨提示', {
							confirmButtonText: '确定',
						});
				} else if (this.id == 't_439a8fabcb614ff29eaa4c2d465004ba') {
					this.$alert(
						'会议因时间冲突等原因决定延期到明年第一季度，具体日期另行通知，请各位老师妥善更改行程，对造成的不便敬请谅解。',
						'温馨提示', {
							confirmButtonText: '确定',
						});
				}

				// else if(this.id == 't_c997fd495a1e47558da5bceb5b58f028'){

				// 	this.$alert('本会议延期到7月中旬，暂不开放报名，会务组近日确认完具体日期再开放，详情请联系客服：微信cmptt666，电话01088378723', '温馨提示', {
				// 		confirmButtonText: '确定',
				// 	});

				// }
				else if (!this.isLogin) {

					//window.top.location.href = "/login";
					this.$router.push({
						path: '/login'
					});
					return;

				} else if (this.detailData.is_black == 1) {

					this.$alert('抱歉，您的账号已被标记为可疑账号，暂无法报名，如需解封请联系客服经理。', '温馨提示', {
						confirmButtonText: '确定',
					});

				} else {
					var url = "/trainingCamp/signup";
					var query = {
						id: this.id
					};
					if (this.path) {
						if (this.coupon_code) {
							query = {
								id: this.id,
								path: this.path,
								coupon_code: this.coupon_code
							};
						} else {
							query = {
								id: this.id,
								path: this.path
							};
						}
					} else {
						if (this.coupon_code) {
							query = {
								id: this.id,
								coupon_code: this.coupon_code
							};
						}
					}
					let routeUrl = this.$router.resolve({
						path: url,
						query: query,
					});
					window.open(routeUrl.href, "_blank");
				}
			},
			studyClick() {
				if (!this.isLogin) {
					//window.top.location.href = "/login";
					this.$router.push({
						path: '/login'
					});
					return;
				} else {
					if (this.detailData.is_open_study != 1) {

						if (this.detailData.is_reg == 0) {

							this.$alert('您已获权，学习中心暂未开放，敬请期待······', '温馨提示', {
								confirmButtonText: '确定'
							});

						} else {

							var url = "/trainingCamp/signup";
							var query = {
								id: this.id
							};
							let routeUrl = this.$router.resolve({
								path: url,
								query: query,
							});
							window.open(routeUrl.href, "_blank");

						}
					} else {
						var url = "/trainingCamp/study";
						var query = {
							id: this.id
						};
						let routeUrl = this.$router.resolve({
							path: url,
							query: query,
						});
						window.open(routeUrl.href, "_blank");
					}
				}
			},
			//QrCode
			setupQrCode(el, url, width, callback) {
				let code_img = new QRCode(el, {
					width: width,
					height: width, // 高度
					text: url, // 二维码内容
					colorDark: '#333333',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.L,
				});
				if (callback) callback(code_img);
			},
		},
	};
</script>

<style>
	.notebox {
		width: 750px !important;
	}
</style>
<style lang="scss" scoped>
	.page-main {
		width: 100%;
		min-height: 100vh;
		background: #F1F1F1;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;

		/deep/.camp_detail_container {
			display: flex;
			width: 100%;
			flex-direction: column;




			.el-menu.el-menu--horizontal {
				border-bottom: none;
				background-color: transparent;
			}

			.el-menu--horizontal>.el-submenu .el-submenu__title {
				background-color: transparent;
				border: 1px solid rgb(201, 58, 46) !important;
				border-bottom: 1px solid rgb(201, 58, 46) !important;
				color: rgb(201, 58, 46) !important;
				border-radius: 30px;
				width: 142px;
				height: 30px;
				line-height: 1;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
				margin-right: 30px;
				font-size: 16px;
				box-sizing: border-box;
			}

			.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
				color: rgb(201, 58, 46);
				background-color: transparent;
				width: 142px;
				height: 30px;
			}

			.class_product_box {
				width: 150px;
				height: 40px;
				position: fixed;
				top: 200px;
				right: 30px;
				z-index: 999;

				.el-collapse {
					border-top: none;
					border-bottom: none;
					border-radius: 10px;
				}

				.el-collapse-item__content {
					padding-bottom: 0 !important;
				}

				.el-collapse-item:last-child .el-collapse-item__header {
					border-radius: 10px !important;
				}

				.el-collapse-item:last-child .el-collapse-item__header.is-active {
					border-radius: 10px 10px 0 0 !important;
				}

				.el-collapse-item:last-child.is-active .el-collapse-item__wrap {
					border-radius: 0 0 10px 10px !important;
				}

				.el-collapse-item__header.is-active {
					border-bottom-color: #eee !important;
				}

				.class_product_box_title {
					font-size: 16px;
					width: 150px;
					height: 48px;
					border-radius: 10px;
					background-color: #fff;
					box-shadow: 0 5px 30px 0 rgba(46, 49, 72, .06);
					display: inline-flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
					color: #333;
					
					.icon{
						color: #666;
						margin-left: 5px;
						transform: rotate(90deg);
					}
					
					&:hover{
						color: #F6892E;
						
						.icon{
							color: #F6892E;
						}
					}
				}

				.class_product_items {
					width: 150px;
					background-color: #fff;
					border-radius: 10px;
					box-shadow: 0 5px 30px 0 rgba(46, 49, 72, .06);

					.class_product_item {
						width: 150px;
						height: 66px;
						position: relative;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						cursor: pointer;
						border-bottom: 1px solid #eee;
						background-color: #fff;

						.current {
							position: absolute;
							left: 0;
							top: 0;
							width: 0;
							height: 0;
							border-top: 14px solid #F6892E;
							border-bottom: 14px solid transparent;
							border-left: 14px solid #F6892E;
							border-right: 14px solid transparent;

							.icon {
								font-size: 12px;
								color: #fff;
								position: absolute;
								left: -10px;
								top: -10px;
							}
						}

						.time {
							font-size: 14px;
							color: #999;
						}

						.title {
							font-size: 16px;
							color: #333;
							display: flex;
							justify-content: space-between;
							
							.class_order_title{
								margin-right: 4px;
							}
						}


						&:nth-of-type(1) {
							border-radius: 10px 10px 0 0;
						}

						&:nth-last-of-type(1) {
							border-radius: 0 0 10px 10px;
						}

						&.active,
						&:hover {
							&:nth-of-type(1) {
								.current {
									border-radius: 10px 0 0 0;
								}
							}

							.title {
								color: #F6892E;
							}
						}


					}
				}

				.close_box {
					width: 150px;
					display: flex;
					flex-direction: column;
					align-items: center;

					.line {
						width: 0;
						height: 8px;
						border-right: 2px solid #e3e3e8;
					}

					.close {
						width: 32px;
						height: 32px;
						background-color: #fff;
						border-radius: 50%;
						box-sizing: border-box;
						display: inline-flex;
						justify-content: center;
						align-items: center;
						box-shadow: 0 5px 30px 0 rgba(46, 49, 72, .06);
						cursor: pointer;

						.icon {
							color: #999;
							font-size: 14px;
						}
					}
					
					&:hover{
						.close {
							.icon {
								color: #333;
							}
						}
					}
				}
			}
		}
	}
</style>